import React from "react";
// import { PageTitle } from '../../layout/core'
import AllChats from "./AllChats";

const ConversationsPage: React.FC<any> = () => {
  return (
    <>
      <div className="mx-5 w-100">
        <AllChats />
      </div>
    </>
  );
};

export default ConversationsPage;
